/** Put the platform banner immediately after the mobile hero, in document flow.
 * Consent content, choices and platform event handlers remain untouched. */
const mobile = matchMedia('(max-width: 767px)');
function placeConsent() {
  const hero = document.querySelector('.tdp-hero')?.closest('.shopify-section');
  const banner = document.getElementById('shopify-pc__banner');
  // Mobiel: banner in de documentstroom, na de hero (home) of anders onderaan de hoofdinhoud,
  // zodat swatches, dropzone en koopknoppen nooit bedekt worden.
  const anchor = hero || document.querySelector('main#MainContent, main');
  const inline = Boolean(mobile.matches && anchor && banner);
  document.body.classList.toggle('tdp-consent-inline', inline);
  if (inline && anchor.nextElementSibling !== banner) anchor.after(banner);
}
// De banner wordt rechtstreeks in <body> gezet; kinderen van body volstaan.
new MutationObserver(placeConsent).observe(document.body, { childList: true });
mobile.addEventListener('change',placeConsent);
placeConsent();
